import { render, staticRenderFns } from "./TranscribePairsList.vue?vue&type=template&id=4d66fc46&scoped=true"
import script from "./TranscribePairsList.vue?vue&type=script&lang=js"
export * from "./TranscribePairsList.vue?vue&type=script&lang=js"
import style0 from "./TranscribePairsList.vue?vue&type=style&index=0&id=4d66fc46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d66fc46",
  null
  
)

export default component.exports